import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Form, Dropdown, Card } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import './AdminPreviousExperience.css';
import Navbar from "../../Pages/Navbar/AdminNavbar";
import Swal from 'sweetalert2';
import BaseUrl from '../../ApiServices/BaseUrl'
import { DOMESTIC_HELPER_POSITIONS, HOSPITALITY_POSITIONS, SOFTWARE_IT_POSITIONS, CONSTRUCTION_POSITIONS, RETAIL_SALES_POSITIONS, CLEANING_MAINTENANCE_POSITIONS } from '../../../Constants/dropdownOptions';

const JOB_POSITIONS_LIST = [
  "Home Care Nurse", "Company Driver",
  "Light Driver", ...DOMESTIC_HELPER_POSITIONS, "Driver (Company / House)",
  "Bus Driver", "Plumber", "Taxi Driver", "Operator",
  "Electrician", "Welder", "Nurse",
  "Hospital Nurse", "Physiotherapy",
  "Hospital Doctor", "Resident Doctor", "Heavy Driver", "Bike Driver",
  "JCB Operator", "Bulldozer Operator", "Excavator Operator", "Loader Operator",
  "Skid Steer Loader Operator", "Grader Operator", "Trench Excavator / Trencher Operator",
  "Backhoe Operator", "Dragline Operator", "Scraper Operator", "Crane Operator",
  "Telehandler Operator", "Reach Stacker Operator", "Boom Lift / Cherry Picker Operator",
  "Container Handler Operator", "Road Roller Operator", "Asphalt Paver Operator",
  "Bitumen Sprayer Operator", "Concrete Paver Operator", "Soil Stabilizer Operator",
  "Drilling Machine / Drill Rig Operator", "Rock Breaker / Hydraulic Hammer Operator",
  "Loader-Dumper Operator", "Dump Truck Operator", "Stone Crusher Operator",
  "Grizzly Feeder / Conveyor Operator", "Tractor Operator", "Harvester / Combine Operator",
  "Dozer / Land Leveling Operator", "Tower Crane Operator", "Mobile Crane Operator",
  "Crawler Crane Operator", "Piling Machine Operator", "Concrete Mixer Truck Operator",
  "Concrete Pump Operator", "Compactor Operator", "Pipe Layer Operator",
  "Forklift / Warehouse Equipment Operator", "Boom Truck / Loader Crane Operator",
  "Road Sweeper Operator", "Water Tanker / Firefighting Vehicle Operator",
  "Excavator Mounted Drill Operator", "Heavy Truck / Tip Truck Operator",
  "Loader Excavator Operator", "Teleporter Crane Operator",
  "Material Handler / Port Crane Operator", "Hydraulic Excavator Operator",
  "Multi-Functional Heavy M", "Workers", "Skilled Workers", "Construction Workers",
  "Skilled Construction Workers", "Mason", "Carpenter", "Steel Fixer", "Painter",
  "AC Technician", "HVAC Technician", "Chiller Technician",
  "Lathe & Milling Machine", "Lathe Machine Operator", "Milling Machine Operator",
  "Heavy Equipment Operator", "Scaffolder", "Healthcare Assistants", "Doctors",
  "Lab Technicians", "Physiotherapists", "Elderly Care Workers",
  ...HOSPITALITY_POSITIONS, ...SOFTWARE_IT_POSITIONS, ...CONSTRUCTION_POSITIONS, ...RETAIL_SALES_POSITIONS, ...CLEANING_MAINTENANCE_POSITIONS, "Factory Workers", "Production Workers",
  "Warehouse Workers", "Packing Staff", "Machine Operators", "Assembly Line Workers",
  "Forklift Operators", "Delivery Drivers", "Truck Drivers", "Logistics Staff",
  "Farm Workers", "Fruit Pickers", "Dairy Workers", "Poultry Workers",
  "Greenhouse Workers", "Caretakers", "CNC Machinist",
  "CNC Programmer", "CNC Milling Programmer", "CNC Turning Programmer",
  "CNC 5-Axis Programmer", "CNC CAD/CAM Programmer", "CNC Setter",
  "CNC Setup Operator", "CNC Quality Inspector (CMM)", "CNC Maintenance Technician",
  "CNC Tool Room Technician", "CNC Production Technician", "CNC Machine Operator",
  "CNC Milling Operator", "CNC Turning Operator", "CNC Lathe Operator",
  "CNC VMC Operator", "CNC HMC Operator", "CNC Operator", "Machine Operator",
  "Assembly Line Worker", "Production Worker", "MIG Welder", "TIG Welder",
  "Industrial Welder", "Fabricator", "Steel Structure Welder",
  "Heavy Truck Mechanic", "Diesel Mechanic", "Auto Mechanic", "Bus Mechanic",
  "Vehicle Technician", "Industrial Electrician", "Maintenance Electrician",
  "Panel Electrician", "Maintenance Technician", "Electrical Technician",
  "PLC Technician", "Automation Technician", "Construction Worker",
  "Warehouse Worker", "Forklift Operator", "Picker & Packer",
  "Delivery Van Driver", "Logistics Assistant", "Heavy Truck Driver (CE)",
  "Trailer Driver", "Chef", "Kitchen Assistant", "Hotel Housekeeping",
  "Medical Technician", "Instrument Technician", "Mechanical Maintenance Technician",
  "Heavy Equipment Mechanic", "6G Welder", "Structural Welder", "Shipyard Welder",
  "FCAW Welder (Shipyard)", "MIG/MAG Welder (Shipyard)", "TIG Welder (Shipyard)",
  "6G Pipe Welder (Shipyard)", "Heavy Trailer Driver", "Fuel Tanker Driver",
  "Ready-Mix Driver", "Registered Nurse", "Professional Chef", "Home Nurse"
];

const jobPositions = [...new Set(JOB_POSITIONS_LIST)];

const countriesWorked = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola',
  'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia',
  'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh',
  'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil',
  'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde',
  'Cambodia', 'Cameroon', 'Canada', 'Central African Republic',
  'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo',
  'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic',
  'Democratic Republic of the Congo', 'Denmark', 'Djibouti',
  'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador',
  'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea',
  'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France',
  'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece',
  'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
  'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia',
  'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Ivory Coast',
  'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati',
  'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho',
  'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
  'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta',
  'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico',
  'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro',
  'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal',
  'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria',
  'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan',
  'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay',
  'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania',
  'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia',
  'Saint Vincent and the Grenadines', 'Samoa', 'San Marino',
  'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia',
  'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia',
  'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa',
  'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan',
  'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan',
  'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga',
  'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan',
  'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates (UAE)',
  'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan',
  'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen',
  'Zambia', 'Zimbabwe'
];

const GCC_COUNTRIES = ['Qatar', 'Saudi Arabia', 'Oman', 'Bahrain', 'Kuwait', 'United Arab Emirates (UAE)'];

const dutiesList = [...new Set(JOB_POSITIONS_LIST)];

const years = Array.from({ length: 30 }, (_, i) => (new Date().getFullYear() - i).toString());
const months = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];
const days = Array.from({ length: 31 }, (_, i) => (i + 1).toString());

const selectedButtonStyle = {
  backgroundColor: '#0d47a1',
  color: 'white',
  borderColor: '#0d47a1'
};

const CustomDropdown = ({
  title,
  field,
  expIndex,
  options,
  selectedValue,
  onSelect,
  multiple = false,
  disabled = false,
  menuClassName = ''
}) => {
  const [localSearchTerm, setLocalSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const filteredOptions = options.filter(option =>
    option.toString().toLowerCase().includes(localSearchTerm.toLowerCase())
  );

  const handleItemClick = (option, e) => {
    if (multiple) {
      e.preventDefault();
      e.stopPropagation();
    }
    onSelect(expIndex, field, option, multiple);
    if (!multiple) {
      setLocalSearchTerm('');
      setIsOpen(false);
    }
  };

  const getSelectedCountFromDropdown = () => {
    if (!multiple || !selectedValue || !Array.isArray(selectedValue)) return 0;
    return selectedValue.filter(item => options.includes(item)).length;
  };

  const selectedCount = getSelectedCountFromDropdown();

  return (
    <Dropdown
      className="mb-3"
      show={isOpen}
      onToggle={(nextShow) => setIsOpen(nextShow)}
    >
      <Dropdown.Toggle
        variant="light"
        className="dropdown-select w-100 d-flex justify-content-between align-items-center"
        id={`dropdown-${field}-${expIndex}`}
        disabled={disabled}
      >
        {multiple ?
          (selectedCount > 0 ? `${selectedCount} selected` : title) :
          (selectedValue || title)}
      </Dropdown.Toggle>
      <Dropdown.Menu className={`w-100 ${menuClassName}`}>
        <div className="px-2 py-1 sticky-top bg-white border-bottom shadow-sm" style={{ zIndex: 1, top: '-5px' }}>
          <Form.Control
            type="text"
            placeholder={`Search ${title.toLowerCase()}...`}
            value={localSearchTerm}
            onChange={(e) => setLocalSearchTerm(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            className="mb-2"
            autoFocus
          />
        </div>
        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, idx) => (
              <Dropdown.Item
                key={`${option}-${idx}`}
                active={multiple ? (Array.isArray(selectedValue) && selectedValue.includes(option)) : selectedValue === option}
                onClick={(e) => handleItemClick(option, e)}
              >
                {option}
                {multiple && Array.isArray(selectedValue) && selectedValue.includes(option) && (
                  <span className="float-end text-primary">✓</span>
                )}
              </Dropdown.Item>
            ))
          ) : (
            <Dropdown.Item disabled>No matches found</Dropdown.Item>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const AdminPreviousExperience = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const userId = location.state?.userId || user.id || '';

  const [selected, setSelected] = useState({
    experience: [{
      job_position: [],
      country: [],
      other_country: '',
      start_year: '',
      end_year: '',
      employer_type: '',
      employer_nationality: '',
      house_duties: [],
      other_job_position: '',
      join_date: '',
      join_month: '',
      join_year: '',
      exit_date: '',
      exit_month: '',
      exit_year: '',
    }],
    reference_letter: '',
    isLoading: false,
    isSaved: false,
    error: null
  });

  // Fetch data from API
  useEffect(() => {
    const fetchExperienceData = async () => {
      try {
        console.log("Fetching experience data for userId:", userId);
        const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`);

        if (response.ok) {
          const data = await response.json();
          console.log("Raw experience data received from API:", data);

          // Parse the experience data correctly
          let experienceData = [];
          if (data && data.experience) {
            if (typeof data.experience === 'string') {
              try {
                experienceData = JSON.parse(data.experience);
              } catch (e) {
                console.error("Error parsing experience data:", e);
                experienceData = [];
              }
            } else if (Array.isArray(data.experience)) {
              experienceData = data.experience;
            } else {
              experienceData = [data.experience];
            }
          }

          console.log("Parsed experience data:", experienceData);

          // Convert reference_letter from boolean/1/0 to 'Yes'/'No'
          const referenceLetterValue = data.reference_letter === true || data.reference_letter === 1 ? 'Yes' :
            data.reference_letter === false || data.reference_letter === 0 ? 'No' : '';

          setSelected(prev => ({
            ...prev,
            experience: experienceData.length > 0 ? experienceData.map(exp => ({
              job_position: Array.isArray(exp.job_position) ? exp.job_position : [exp.job_position].filter(Boolean),
              country: Array.isArray(exp.country) ? exp.country : [exp.country].filter(Boolean),
              other_country: exp.other_country || '',
              start_year: exp.start_year || '',
              end_year: exp.end_year || '',
              employer_type: exp.employer_type || '',
              employer_nationality: exp.employer_nationality || '',
              house_duties: Array.isArray(exp.house_duties) ? exp.house_duties : [exp.house_duties].filter(Boolean),
              other_job_position: exp.other_job_position || '',
              join_date: exp.join_date || '',
              join_month: exp.join_month || '',
              join_year: exp.join_year || '',
              exit_date: exp.exit_date || '',
              exit_month: exp.exit_month || '',
              exit_year: exp.exit_year || '',
            })) : [{
              job_position: [],
              country: [],
              other_country: '',
              start_year: '',
              end_year: '',
              employer_type: '',
              employer_nationality: '',
              house_duties: [],
              other_job_position: '',
              join_date: '',
              join_month: '',
              join_year: '',
              exit_date: '',
              exit_month: '',
              exit_year: '',
            }],
            reference_letter: referenceLetterValue,
            isSaved: experienceData.length > 0
          }));
        } else if (response.status !== 404) {
          throw new Error('Failed to fetch experience data');
        } else {
          console.warn("No experience data found for userId:", userId);
          // Initialize with empty experience if no data found
          setSelected(prev => ({
            ...prev,
            experience: [{
              job_position: [],
              country: [],
              other_country: '',
              start_year: '',
              end_year: '',
              employer_type: '',
              employer_nationality: '',
              house_duties: [],
              other_job_position: '',
              join_date: '',
              join_month: '',
              join_year: '',
              exit_date: '',
              exit_month: '',
              exit_year: '',
            }],
            isSaved: false
          }));
        }
      } catch (err) {
        console.error('Error fetching experience data:', err);
        setSelected(prev => ({ ...prev, error: err.message }));
      }
    };

    if (userId) {
      fetchExperienceData();
    }
  }, [userId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleSelection = (expIndex, category, value, multiple = true) => {
    setSelected(prev => {
      const updatedExperience = [...prev.experience];

      if (multiple) {
        const alreadySelected = updatedExperience[expIndex][category].includes(value);
        const newSelection = alreadySelected
          ? updatedExperience[expIndex][category].filter(item => item !== value)
          : [...updatedExperience[expIndex][category], value];

        // For arrays with limits
        if ((category === 'country' || category === 'house_duties') && newSelection.length > 6) {
          return prev;
        }

        updatedExperience[expIndex] = {
          ...updatedExperience[expIndex],
          [category]: newSelection,
        };
      } else {
        updatedExperience[expIndex] = {
          ...updatedExperience[expIndex],
          [category]: value,
        };
      }

      return {
        ...prev,
        experience: updatedExperience,
        isSaved: false
      };
    });
  };

  const handleChange = (expIndex, field, value) => {
    setSelected(prev => {
      const updatedExperience = [...prev.experience];
      updatedExperience[expIndex] = {
        ...updatedExperience[expIndex],
        [field]: value
      };
      return {
        ...prev,
        experience: updatedExperience,
        isSaved: false
      };
    });
  };

  const addNewExperience = () => {
    setSelected(prev => ({
      ...prev,
      experience: [
        ...prev.experience,
        {
          job_position: [],
          country: [],
          other_country: '',
          start_year: '',
          end_year: '',
          employer_type: '',
          employer_nationality: '',
          house_duties: [],
          other_job_position: '',
          join_date: '',
          join_month: '',
          join_year: '',
          exit_date: '',
          exit_month: '',
          exit_year: '',
        }
      ],
      isSaved: false
    }));
  };

  const removeExperience = (index) => {
    if (selected.experience.length <= 1) return;

    setSelected(prev => {
      const updatedExperience = [...prev.experience];
      updatedExperience.splice(index, 1);
      return {
        ...prev,
        experience: updatedExperience,
        isSaved: false
      };
    });
  };

  const saveData = async () => {
    setSelected(prev => ({ ...prev, isLoading: true, error: null }));

    // Show loading alert
    Swal.fire({
      title: 'Saving...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const dataToSend = {
        user_id: userId,
        experience: selected.experience.map(exp => ({
          job_position: exp.job_position,
          other_job_position: exp.other_job_position,
          country: exp.country,
          other_country: exp.other_country,
          start_year: exp.start_year,
          end_year: exp.end_year,
          employer_type: exp.employer_type,
          employer_nationality: exp.employer_nationality,
          house_duties: exp.house_duties,
          join_date: exp.join_date,
          join_month: exp.join_month,
          join_year: exp.join_year,
          exit_date: exp.exit_date,
          exit_month: exp.exit_month,
          exit_year: exp.exit_year,
        })),
        reference_letter: selected.reference_letter === 'Yes'
      };

      const response = await fetch(`${BaseUrl}/api/job-seeker`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || result.message || 'Failed to save data');
      }

      await Swal.fire({
        title: 'Success!',
        text: 'Your experience information has been saved successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6',
      });

      setSelected(prev => ({ ...prev, isSaved: true }));
      return result;
    } catch (err) {
      console.error('Error saving data:', err);

      await Swal.fire({
        title: 'Error!',
        text: err.message || 'Failed to save data. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      setSelected(prev => ({ ...prev, error: err.message }));
      throw err;
    } finally {
      setSelected(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleBack = () => {
    navigate('/adminmyskills', { state: { userId } });
  };

  const handleSaveNext = async () => {
    try {
      await saveData();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
      setTimeout(() => {
        navigate('/admineducation', { state: { userId } });
      }, 100);
    } catch (err) { }
  };

  const isSkillSelected = (category, skill, expIndex = 0) => {
    return selected.experience[expIndex][category].includes(skill);
  };

  return (
    <>
      <Navbar />
      <div className="skills-wrapper" style={{ marginTop: "84px" }}>
        <Container className="mt-4 px-4 pb-5">
          <Card className="shadow border-0 previous-experience-card">
            <Card.Header className="previous-experience-header">
              <h2 className="m-0 text-white text-center">
                <i className="bi bi-briefcase me-2"></i>
                Previous Experience
              </h2>
            </Card.Header>
            <Card.Body className="previous-experience-body">
              {selected.experience.map((exp, expIndex) => (
                <div key={expIndex} className="experience-section mb-5">
                  {expIndex > 0 && (
                    <div className="d-flex justify-content-end mb-3">
                      <Button
                        variant="danger"
                        onClick={() => removeExperience(expIndex)}
                        disabled={selected.isLoading}
                      >
                        Remove Experience
                      </Button>
                    </div>
                  )}

                  <h4>Select your previous Job Position</h4>

                  <Row className="mt-3">
                    {jobPositions.slice(0, 4).map((position, idx) => (
                      <Col xs={6} md={3} className="mb-3" key={idx}>
                        <Button
                          variant="primary"
                          className={`language-btn w-100 job-btn ${isSkillSelected('job_position', position, expIndex) ? 'selected-button' : ''}`}
                          onClick={() => toggleSelection(expIndex, 'job_position', position)}
                          disabled={selected.isLoading}
                          style={isSkillSelected('job_position', position, expIndex) ? selectedButtonStyle : {}}
                        >
                          {position}
                          {isSkillSelected('job_position', position, expIndex) && (
                            <span className="ms-2">✓</span>
                          )}
                        </Button>
                      </Col>
                    ))}


                    <Col xs={12} className="mb-1">
                      <CustomDropdown
                        title="Select other previous job position"
                        field="job_position"
                        expIndex={expIndex}
                        options={jobPositions.slice(4)}
                        selectedValue={exp.job_position || []}
                        onSelect={toggleSelection}
                        multiple={true}
                        disabled={selected.isLoading}
                        menuClassName="personalinfo-nationality-menu"
                      />
                    </Col>
                  </Row>

                  <div className="mt-1 mb-4">
                    <Form.Control
                      type="text"
                      placeholder="Enter other job positions not listed above"
                      className="professional-input"
                      value={exp.other_job_position || ''}
                      onChange={(e) => handleChange(expIndex, 'other_job_position', e.target.value)}
                      disabled={selected.isLoading}
                    />
                  </div>

                  <div>
                    <h4 className="mb-3 fw-semibold text-dark">
                      <div className="d-flex flex-column align-items-start">
                        <div>Select the previous worked country</div>
                        <p className="language-note ms-0 mb-0 mt-1" style={{ fontSize: '15px', color: '#6c757d' }}>
                          (You can select maximum 4 countries)
                        </p>
                      </div>
                    </h4>

                    <Row className="mt-3">
                      {GCC_COUNTRIES.map((country, idx) => (
                        <Col xs={6} md={4} className="mb-3" key={idx}>
                          <Button
                            variant="primary"
                            className={`w-100 country-btn ${isSkillSelected('country', country, expIndex) ? 'selected-button' : ''}`}
                            onClick={() => toggleSelection(expIndex, 'country', country)}
                            disabled={(exp.country.length >= 4 && !exp.country.includes(country)) || selected.isLoading}
                            style={isSkillSelected('country', country, expIndex) ? selectedButtonStyle : {}}
                          >
                            {country}
                            {isSkillSelected('country', country, expIndex) && (
                              <span className="ms-2">✓</span>
                            )}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    <div className="mt-3">
                      <CustomDropdown
                        title="Select other previous worked country"
                        field="country"
                        expIndex={expIndex}
                        options={countriesWorked.filter(c => !GCC_COUNTRIES.includes(c))}
                        selectedValue={exp.country}
                        onSelect={toggleSelection}
                        multiple={true}
                        disabled={selected.isLoading || exp.country.length >= 4}
                        menuClassName="personalinfo-nationality-menu"
                      />
                    </div>

                    <div className="mt-3 mb-4">
                      <Form.Control
                        type="text"
                        placeholder="Enter other countries you have worked in (comma separated)"
                        className="professional-input"
                        value={exp.other_country || ''}
                        onChange={(e) => handleChange(expIndex, 'other_country', e.target.value)}
                        disabled={selected.isLoading}
                      />
                    </div>
                  </div>

                  <div className="employer-type-section mt-1">
                    <h4>Type of previous employer</h4>
                    <Row className="gx-2 mt-2">
                      {['Family', 'Company', 'Both'].map((type) => (
                        <Col xs={4} className="mb-2" key={type}>
                          <Button
                            className={`w-100 employer-type-btn ${exp.employer_type === type ? 'selected-button' : ''}`}
                            onClick={() => toggleSelection(expIndex, 'employer_type', type, false)}
                            disabled={selected.isLoading}
                            style={exp.employer_type === type ? selectedButtonStyle : {}}
                          >
                            {type}
                            {exp.employer_type === type && (
                              <span className="ms-2">✓</span>
                            )}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  <div className="employer-nationality-section mt-1">
                    <h4>Previous employer nationality?</h4>
                    <Row className="mt-3">
                      {GCC_COUNTRIES.map((country, idx) => (
                        <Col xs={6} md={4} className="mb-3" key={idx}>
                          <Button
                            className={`w-100 employer-country-btn ${exp.employer_nationality === country ? 'selected-button' : ''}`}
                            onClick={() => toggleSelection(expIndex, 'employer_nationality', country, false)}
                            disabled={selected.isLoading}
                            style={exp.employer_nationality === country ? selectedButtonStyle : {}}
                          >
                            {country}
                            {exp.employer_nationality === country && (
                              <span className="ms-2">✓</span>
                            )}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                    <div className='mb-1'>
                      <CustomDropdown
                        title="Select other country name if any"
                        field="employer_nationality"
                        expIndex={expIndex}
                        options={countriesWorked.filter(c => !GCC_COUNTRIES.includes(c))}
                        selectedValue={exp.employer_nationality}
                        onSelect={(idx, field, value) => toggleSelection(idx, field, value, false)}
                        disabled={selected.isLoading}
                        menuClassName="personalinfo-nationality-menu"
                      />
                    </div>
                  </div>

                  <h4 className="mb-3 fw-semibold text-dark">
                    <div className="d-flex flex-column align-items-start">
                      <div>Duties in previous employer's house?</div>
                      <p className="language-note ms-0 mb-0 mt-1" style={{ fontSize: '15px', color: '#6c757d' }}>
                        (You can select Maximum 6 duties in total)
                      </p>
                    </div>
                  </h4>

                  <Row>
                    {dutiesList.slice(0, 6).map((duty, index) => (
                      <Col xs={6} md={4} key={index} className="mb-3">
                        <Button
                          className={`w-100 duties-btn ${isSkillSelected('house_duties', duty, expIndex) ? 'selected-button' : ''}`}
                          onClick={() => toggleSelection(expIndex, 'house_duties', duty)}
                          disabled={(exp.house_duties.length >= 6 && !exp.house_duties.includes(duty)) || selected.isLoading}
                          style={isSkillSelected('house_duties', duty, expIndex) ? selectedButtonStyle : {}}
                        >
                          {duty}
                          {isSkillSelected('house_duties', duty, expIndex) && (
                            <span className="ms-2">✓</span>
                          )}
                        </Button>
                      </Col>
                    ))}
                  </Row>

                  <div className='mb-3'>
                    <CustomDropdown
                      title="Select other duties"
                      field="house_duties"
                      expIndex={expIndex}
                      options={dutiesList.slice(12)}
                      selectedValue={exp.house_duties}
                      onSelect={toggleSelection}
                      multiple={true}
                      disabled={selected.isLoading}
                      menuClassName="personalinfo-nationality-menu"
                    />
                  </div>

                  <div className="mt-3 mb-4">
                    <Form.Control
                      type="text"
                      placeholder="Enter additional duties not listed above (comma separated)"
                      className="professional-input"
                      value={exp.other_job_position || ''}
                      onChange={(e) => handleChange(expIndex, 'other_job_position', e.target.value)}
                      disabled={selected.isLoading}
                    />
                  </div>

                  <div className="last-job-section my-4 mt-1">
                    <h4 className="mb-3 fw-semibold text-dark">
                      <div className="d-flex flex-column align-items-start">
                        <div>Which country was your last job in?</div>
                        <p className="language-note ms-0 mb-0 mt-1" style={{ fontSize: '15px', color: '#6c757d' }}>
                          (Select your last job and country name)
                        </p>
                      </div>
                    </h4>

                    <CustomDropdown
                      title="Which country was your last job"
                      field="country"
                      expIndex={expIndex}
                      options={countriesWorked}
                      selectedValue={exp.country[0] || ''}
                      onSelect={(expIndex, field, value) => handleChange(expIndex, field, [value])}
                      disabled={selected.isLoading}
                      menuClassName="personalinfo-nationality-menu"
                    />

                    <h4 className="mb-2">Job Start Date</h4>
                    <Row className="gx-3 gy-2 align-items-center">
                      <Col xs={4}>
                        <CustomDropdown title="Day" field="join_date" expIndex={expIndex} options={days} selectedValue={exp.join_date} onSelect={handleChange} disabled={selected.isLoading} menuClassName="personalinfo-nationality-menu" />
                      </Col>
                      <Col xs={4}>
                        <CustomDropdown title="Month" field="join_month" expIndex={expIndex} options={months} selectedValue={exp.join_month} onSelect={handleChange} disabled={selected.isLoading} menuClassName="personalinfo-nationality-menu" />
                      </Col>
                      <Col xs={4}>
                        <CustomDropdown title="Year" field="join_year" expIndex={expIndex} options={years} selectedValue={exp.join_year} onSelect={handleChange} disabled={selected.isLoading} menuClassName="personalinfo-nationality-menu" />
                      </Col>
                    </Row>

                    <h4 className="mb-2 mt-3">Job End Date</h4>
                    <Row className="gx-3 gy-2 align-items-center">
                      <Col xs={4}>
                        <CustomDropdown title="Day" field="exit_date" expIndex={expIndex} options={days} selectedValue={exp.exit_date} onSelect={handleChange} disabled={selected.isLoading} menuClassName="personalinfo-nationality-menu" />
                      </Col>
                      <Col xs={4}>
                        <CustomDropdown title="Month" field="exit_month" expIndex={expIndex} options={months} selectedValue={exp.exit_month} onSelect={handleChange} disabled={selected.isLoading} menuClassName="personalinfo-nationality-menu" />
                      </Col>
                      <Col xs={4}>
                        <CustomDropdown title="Year" field="exit_year" expIndex={expIndex} options={years} selectedValue={exp.exit_year} onSelect={handleChange} disabled={selected.isLoading} menuClassName="personalinfo-nationality-menu" />
                      </Col>
                    </Row>
                  </div>
                </div>
              ))}

              <div className="d-flex justify-content-end add-exp-button">
                <Button className="add-more-btn-small" onClick={addNewExperience} disabled={selected.isLoading}>
                  <span className="fs-5">+</span> Add other experience
                </Button>
              </div>

              <h4 className="reference-title mb-3">Do you have a reference letter?</h4>
              <Row className="mb-3">
                <Col xs={6}>
                  <Button className={`w-100 reference-btn ${selected.reference_letter === 'Yes' ? 'selected-button' : ''}`} onClick={() => setSelected(prev => ({ ...prev, reference_letter: 'Yes', isSaved: false }))} disabled={selected.isLoading} style={selected.reference_letter === 'Yes' ? selectedButtonStyle : {}}>Yes</Button>
                </Col>
                <Col xs={6}>
                  <Button className={`w-100 reference-btn ${selected.reference_letter === 'No' ? 'selected-button' : ''}`} onClick={() => setSelected(prev => ({ ...prev, reference_letter: 'No', isSaved: false }))} disabled={selected.isLoading} style={selected.reference_letter === 'No' ? selectedButtonStyle : {}}>No</Button>
                </Col>
              </Row>

              <div className="additional-section mb-4">
                <div className="d-flex justify-content-between gap-2" style={{ width: "100%" }}>
                  <button className="nav-btn" style={{ flex: 1 }} onClick={handleBack} disabled={selected.isLoading}>Back</button>
                  <button className="nav-btn" style={{ flex: 1 }} onClick={handleSaveNext}>Next</button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default AdminPreviousExperience;
